import React, { useState } from "react";
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import { LineChart } from '@mui/x-charts/LineChart';

export default ({dashboardList}) => {
    const [selectedInterval, setSelectedInterval] = useState("monthly");

    const data = {
        monthly: {
            uData:dashboardList?.user_data?.monthWiseData.length > 0 ? dashboardList?.user_data?.monthWiseData : [0,0,0,0,0,0,0,0,0,0,0,0],
            pData: dashboardList?.coach_data?.monthWiseData.length > 0 ? dashboardList?.coach_data?.monthWiseData : [0,0,0,0,0,0,0,0,0,0,0,0],
            xLabels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        },
    };

    const sizing = {
        margin: { right: 5, top:25},
        height: 350, // Adjust height as needed
        legend: { hidden: true },
    };
    
    return(
        <>
            <div className="row">
                <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <h4><b>Monthly</b></h4>
                                <div className='col-md-6'>
                                    <LineChart
                                        xAxis={[{ data: data[selectedInterval].xLabels, scaleType: 'band' }]}
                                        series={[
                                            { data: data[selectedInterval].uData, label: 'users', id: 'user', area:true, color:"#19204a"  },
                                            { data: data[selectedInterval].pData, label: 'coach', id: 'coachId', area:true, color:"#84a23e" },
                                        ]}
                                        width={550}
                                        height={400}
                                    />
                                </div>
                                <div className='col-md-6'>
                                    <PieChart
                                        series={[
                                            {
                                                data: data[selectedInterval]?.uData?.map((value, index) => ({
                                                    value: value,
                                                    color:"#19204a", 
                                                    label: (`Users ${data[selectedInterval]?.xLabels[index]}`),
                                                })),
                                                arcLabel: (item) => `Users ${item.value}`,
                                                arcLabelMinAngle: 45,
                                            },
                                            {
                                                data: data[selectedInterval]?.pData?.map((value, index) => ({
                                                    value: value,
                                                    color:"#84a23e",
                                                    label: (`Coach ${data[selectedInterval]?.xLabels[index]}`),
                                                })),
                                                innerRadius: 60,
                                                arcLabel: (item) => `Coach ${item.value}`,
                                                arcLabelMinAngle: 45,
                                            },
                                        ]}
                                        sx={{
                                            [`& .${pieArcLabelClasses?.root}`]: {
                                                fill: 'white',
                                                fontSize: 10,
                                            },
                                        }}
                                        {...sizing}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
};